export const telephonyEs = {
  admin: {
    title: 'Centro de control de telefonía e IA',
    subtitle:
      'Procesamiento de audio, servicio de transcripción, modelo de lenguaje y activación por usuario.',
    tabEngine: 'Motor de audio e IA',
    tabUsers: 'Activación del usuario',
    error: 'No se pudo cargar la configuración.',
    saved: 'La configuración se ha guardado.',
    engineTitle: 'Motor de audio y STT',
    engineHint:
      'La grabación se obtiene después de la llamada, se transcribe y luego se analiza mediante el modelo de lenguaje.',
    enabled: 'Análisis de IA activo',
    enabledHint: 'Con el análisis desactivado, las grabaciones solo se registran.',
    mode: 'Modo de procesamiento de audio',
    modeHint:
      'La detección automática selecciona según el número de canales: estéreo se transcribe por canal, mono se separa por diarización de hablantes.',
    whisperUrl: 'URL de API de Whisper / WhisperX',
    whisperKey: 'Token de autenticación de Whisper',
    ollamaUrl: 'URL del servidor de Ollama',
    ollamaUrlHint: 'Localmente "http://localhost:11434" o en la red "http://192.168.1.50:11434".',
    ollamaModel: 'Modelo Ollama',
    prompt: 'Indicaciones de extracción',
    promptHint:
      'El marcador de posición {{transcript}} se reemplaza por la transcripción del orador formateada.',
    secretSet: 'Almacenado ({{hint}}). Dejarlo vacío mantiene el valor guardado.',
    secretUnset: 'Ningún token almacenado.',
  },
  modes: {
    AUTO_DETECT: 'Detección automática (estéreo → faster-whisper / mono → WhisperX)',
    STEREO_SPLIT_FASTER_WHISPER: 'Forzado: estéreo de doble canal (faster-whisper)',
    MONO_DIARIZATION_WHISPERX: 'Forzado: mono con diarización de orador (WhisperX)',
    SINGLE_CHANNEL_PLAIN: 'Mono simple sin separación de oradores',
  },
  test: {
    title: 'Prueba de pipeline',
    subtitle:
      'Suba un archivo de prueba y verifique toda la cadena de detección de formato, transcripción y resumen.',
    upload: 'Subir archivo de prueba y verificar pipeline STT/LLM',
    running:
      'La canalización está en funcionamiento. Dependiendo de la longitud, esto toma unos minutos.',
    success: 'La canalización se completó con éxito.',
    failed: 'La canalización terminó con un error.',
    tooLarge: 'El archivo de prueba excede {{size}} MB.',
    transcript: 'Transcripción',
    summary: 'Resumen',
    checkedAt: 'Revisado en {{timestamp}}',
    steps: {
      ANALYSIS: 'Detección de formato',
      TRANSCRIPTION: 'Transcripción',
      SUMMARY: 'Resumen',
    },
  },
  users: {
    title: 'Activación por usuario',
    subtitle:
      'La telefonía está habilitada estrictamente por cuenta de usuario. Sin un id de agente, número de marcado directo o extensión, no se pueden coincidir las llamadas entrantes.',
    error: 'No se pudo cargar la lista de usuarios.',
    empty: 'No hay usuarios.',
    saved: 'La activación ha sido guardada.',
    user: 'Empleado',
    providerUserId: 'Id de agente',
    providerUserIdHint: 'Id de usuario de Ringover, por ejemplo 1234567.',
    numbers: 'Números de teléfono',
    extension: 'Extensión interna',
    extensionPlaceholder: '101',
    directDial: 'Marcación directa (E.164)',
    directDialPlaceholder: '+4961421234512',
    outboundCallerId: 'CLI saliente',
    outboundCallerIdPlaceholder: '+496142123450',
    outboundCallerIdHint: 'Número mostrado a la persona llamada.',
    apiKey: 'Clave API personal',
    apiKeyPlaceholder: 'Introducir una nueva clave',
    apiKeySet: 'Guardada ({{hint}}). Dejar vacío para mantener el valor guardado.',
    apiKeyUnset: 'No hay clave guardada.',
    showKey: 'Mostrar clave',
    hideKey: 'Ocultar clave',
    enabled: 'Activo',
    toggle: 'Habilitar telefonía para {{name}}',
    test: 'Probar',
    testHint: 'Comprobar la conexión usando las credenciales guardadas',
    testRunning: 'La prueba de conexión se está ejecutando.',
    testSuccess: 'Conexión establecida: {{name}}',
    testSuccessAnonymous: 'La conexión con el proveedor funciona.',
    providerHint: 'Proveedores soportados: {{providers}}.',
  },
  webhook: {
    title: 'Endpoint de webhook de Ringover',
    hint: 'Ingrese esta URL y el secreto en el panel de desarrolladores de Ringover para recibir eventos de llamadas y grabaciones en tiempo real.',
    url: 'URL del webhook',
    copy: 'Copiar',
    copied: 'La URL del webhook ha sido copiada.',
    copyFailed: 'No se pudo copiar la URL. Por favor, selecciónela manualmente.',
    secret: 'Secreto global del webhook',
    secretPlaceholder: 'Ingrese un nuevo secreto',
    secretHint:
      'Clave de firma para todas las entregas entrantes. Se aplica a toda la instalación porque Ringover usa exactamente un secreto por integración.',
    secretSet: 'Guardada ({{hint}}). Dejar vacío para mantener el valor guardado.',
    secretUnset: 'Ningún secreto almacenado aún — Las entregas entrantes son rechazadas.',
    masterKey: 'Clave de API de administrador de Ringover (opcional)',
    masterKeyHint:
      'Se utiliza para consultas en toda la instalación y no es estrictamente necesario.',
    save: 'Guardar',
    saved: 'La configuración del proveedor ha sido guardada.',
    error: 'No se pudo cargar la configuración del proveedor.',
  },
  list: {
    subtitle: 'Llamadas con este socio comercial, incluyendo transcripción y análisis de IA.',
    error: 'No se pudo cargar el historial de llamadas.',
    emptyTitle: 'Aún no se han registrado llamadas.',
    emptyHint: 'Tan pronto como se realice una llamada, aparecerá aquí.',
    selectHint: 'Seleccione una llamada para ver su análisis.',
    showTranscript: 'Mostrar transcripción',
    callNow: 'Llamar a {{number}}',
    noPermission: 'No tiene permiso para ver el historial de llamadas.',
  },
  fields: {
    startedAt: 'Hora',
    direction: 'Dirección',
    agent: 'Agente',
    status: 'Estado',
    duration: 'Duración (min)',
    actions: 'Acciones',
  },
  directions: {
    INBOUND: 'Entrante',
    OUTBOUND: 'Saliente',
  },
  statuses: {
    RINGING: 'Timbre',
    ANSWERED: 'Contestadas',
    MISSED: 'Perdida',
    VOICEMAIL: 'Buzón de voz',
    FAILED: 'Fallido',
  },
  sentiments: {
    POSITIVE: 'Positiva',
    NEUTRAL: 'Neutral',
    NEGATIVE: 'Negativa',
    DISPUTED: 'Disputada',
  },
  processing: {
    PENDING: 'El análisis está en cola.',
    DOWNLOADING_AUDIO: 'Obteniendo la grabación …',
    TRANSCRIBING: 'Transcribiendo la llamada …',
    SUMMARIZING: 'El modelo de lenguaje está resumiendo …',
    COMPLETED: 'Análisis completado.',
    FAILED: 'El análisis falló.',
    DISABLED: 'El análisis de IA está desactivado en todo el sistema.',
  },
  summary: {
    title: 'Resumen de IA',
    empty: 'No hay resumen disponible para esta llamada.',
    edit: 'Editar resumen',
    editorLabel: 'Resumen',
    saved: 'El resumen ha sido guardado.',
    editedBadge: 'Editado por {{name}} el {{timestamp}}',
    showOriginal: 'Mostrar texto original de IA',
    actionItems: 'Elementos de acción',
    reprocess: 'Reiniciar análisis',
    reprocessStarted: 'El análisis ha sido reiniciado.',
  },
  transcript: {
    title: 'Transcripción de la llamada',
    subtitle: 'Modo de procesamiento: {{mode}}',
    modeUnknown: 'desconocido',
    empty: 'No hay transcripción disponible para esta llamada.',
    showPlain: 'Texto plano',
    showDialog: 'Diálogo',
    agent: 'Agente',
    customer: 'Cliente',
  },
  screenPop: {
    title: 'Llamada entrante',
    unknown: 'No hay socio comercial almacenado para este número.',
    openDocuments: '{{count}} abrir documentos',
    lastCall: 'Última llamada: {{timestamp}}',
    open: 'Abrir contacto',
    blockedTitle: '🚨 Bloqueado: {{status}}',
    blockedReason: 'Razón: {{reason}}',
  },
  call: {
    started: 'La llamada ha comenzado. Contéstela en su dispositivo.',
    failed: 'No se pudo iniciar la llamada: {{message}}',
  },
} as const;
